import { render, staticRenderFns } from "./PriceOneTheme1.vue?vue&type=template&id=5c455fbb&scoped=true"
import script from "./PriceOneTheme1.vue?vue&type=script&lang=js"
export * from "./PriceOneTheme1.vue?vue&type=script&lang=js"
import style0 from "./PriceOneTheme1.vue?vue&type=style&index=0&id=5c455fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c455fbb",
  null
  
)

export default component.exports